import React from 'react';
import { PropertyTaxCalculator as PropertyTaxCalculator$1 } from '@zillow/zrs-traffic';
import { getNextAppConfig } from '../../util/helpers.js';

var PROPERTY_TAX_CALCULATOR_CONFIGS = {
  prod: {
    zgGraphUrl: 'https://www.zillow.com/zg-graph',
    callerId: 'zrs-traffic',
    mortgageUrl: 'https://mortgageapi.zillow.com/getAnnualPropertyTaxRate',
    mortgagePartnerId: 'RD-WXDQSGN'
  },
  default: {
    zgGraphUrl: 'https://www.qa.zillow.net/graphql',
    callerId: 'zrs-traffic',
    mortgageUrl: 'https://mortgageapi.qa.zillow.net/getAnnualPropertyTaxRate',
    mortgagePartnerId: 'RD-GKZRBBL'
  }
};
var BlockPropertyTaxCalculator = function BlockPropertyTaxCalculator() {
  var NEXT_PUBLIC_ENV = getNextAppConfig('NEXT_PUBLIC_ENV');
  var props = PROPERTY_TAX_CALCULATOR_CONFIGS[NEXT_PUBLIC_ENV] || PROPERTY_TAX_CALCULATOR_CONFIGS.default;
  return /*#__PURE__*/React.createElement(PropertyTaxCalculator$1, props);
};
var PropertyTaxCalculator = BlockPropertyTaxCalculator;

export { PropertyTaxCalculator as default };
